module.exports = __webpack_public_path__ + "static/media/indospace.cea266ae.svg";